import { SET_REVIEWS_INFO, SET_CURR_AVG_AND_TOTAL_RATING } from './types';

/**
 * @param {ReviewsInfo} ReviewsInfo
 * @returns {Object} action
 * @returns {string} action.type - SET_REVIEWS_INFO
 * @returns {ReviewsInfo} action.payload - ReviewsInfo
 */
export const setReviewsInfo = (reviewsInfo) => {
	return {
		type: SET_REVIEWS_INFO,
		payload: reviewsInfo
	};
};

/**
 * @param {number} avgRating
 * @param {number} totalRating
 * @returns {Object} action
 * @returns {string} action.type - SET_CURR_AVG_AND_TOTAL_RATING
 * @returns {Object} action.payload
 * @returns {number} action.payload.avgRating
 * @returns {number} action.payload.totalRating
 */
export const setCurrAvgAndTotalRating = (avgRating, totalRating) => {
	return {
		type: SET_CURR_AVG_AND_TOTAL_RATING,
		payload: { avgRating, totalRating }
	};
};
